import React from "react";
import Draggable from "react-draggable";

export default class CustomTextInfoDraggable extends React.Component {
  constructor(props) {
    super(props);
    this.nodeRef = React.createRef();
  }

  state = {
    controlledPosition: {
      x: this.props.textPosition.x,
      y: this.props.textPosition.y,
    },
    infoHidden: false,
  };

  onControlledDrag = (_, position) => {
    const { x, y } = position;

    this.props.setTextPosition({ x, y });
    this.setState({ controlledPosition: { x, y } });
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.textPosition.x !== prevProps.textPosition.x ||
      this.props.textPosition.y !== prevProps.textPosition.y ||
      this.props.bgOpacity !== prevProps.bgOpacity
    ) {
      this.setState({
        controlledPosition: {
          x: this.props.textPosition.x,
          y: this.props.textPosition.y,
        },
        infoHidden: true,
      });
    }
  }

  render() {
    const { controlledPosition, infoHidden } = this.state;
    const opacity = this.props.bgOpacity ?? 0.5;

    return (
      <Draggable
        nodeRef={this.nodeRef}
        axis="both"
        bounds="parent"
        handle=".text-handle"
        scale={1}
        position={controlledPosition}
        onDrag={this.onControlledDrag}
        disabled={this.props.isDetailMode}
      >
        <div className="absolute bottom-0 left-0" ref={this.nodeRef}>
          <div className="relative w-fit">
            <div
              className={`select-none box-border text-gray-700 ${
                this.props.isDetailMode ? "" : "border border-orange-600"
              }`}
              style={{
                fontSize: "8px",
                lineHeight: "1.2",
                padding: "2px",
                backgroundColor: `rgba(255, 255, 255, ${opacity})`,
              }}
            >
              Dokumen ini telah ditandatangani secara elektronik menggunakan
              sertifikat elektronik yang diterbitkan oleh Peruri
            </div>

            <div
              className={`absolute flex justify-center items-center w-full h-full top-0 left-0 bg-transparent text-handle cursor-move ${
                this.props.isDetailMode ? "hidden" : ""
              }`}
            >
              <div
                className={`bg-white w-16 text-orange-600 text-xs text-center font-semibold select-none ${
                  infoHidden || this.props.isDetailMode ? "hidden" : ""
                }`}
              >
                Drag text
              </div>
            </div>
          </div>
        </div>
      </Draggable>
    );
  }
}
